export default "__VITE_ASSET__DSkLuoeF__"